import { render, staticRenderFns } from "./ODateTimeInput.vue?vue&type=template&id=27fab6a0&scoped=true&"
import script from "./ODateTimeInput.vue?vue&type=script&lang=js&"
export * from "./ODateTimeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fab6a0",
  null
  
)

export default component.exports